import CashierServiceCollection from "../CashierServiceCollection";
import CustomerContactModel from "../../models/cashier/CustomerContactModel";

export default class CustomerContactCollection extends CashierServiceCollection {

  model() {
    return CustomerContactModel;
  }

}
